import styled from "styled-components";
import { motion } from "framer-motion";
import { v, b } from "../../styles/variables";

export const CForm = styled(motion.form)`
	display: flex;
	flex-direction: column;
	position: relative;
	overflow: hidden;

	button {
		margin-top: ${v.largeDist};
		width: 50%;
		align-self: center;
		padding: 0.5rem ${v.smallDist};
	}

	label {
		margin-top: ${v.smallDist};
		margin-bottom: 0.5rem;
	}

	input,
	textarea {
		width: 90%;
		padding: 0.5rem 0;
		background: none;
		border: none;
		border-bottom: 3px solid ${({ theme }) => theme.primary};
		outline: none;
		font-size: 1.4rem;
		font-family: "Outfit", sans-serif;
		font-weight: 300;
		color: ${({ theme }) => theme.text};
	}

	textarea {
		resize: none;
		height: 7rem;
	}

	@media ${b.medium} {
		input,
		textarea {
			width: 90%;
		}

		button {
			width: 35%;
			align-self: flex-start;
		}
	}
`;

export const Success = styled(motion.div)`
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	background: #17e01775;
	padding: 1rem;
	border-radius: 5px;
`;

export const Error = styled(motion.div)`
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	background: #f1570f75;
	padding: 1rem;
	border-radius: 5px;
`;
